import styled from 'styled-components';
import { motion } from 'framer-motion';

export const Main = styled.section`
  padding: 110px 0;
  position: relative;
  z-index: 10;
  background:
    radial-gradient(circle at 15% 15%, ${(props) => props.theme.text}14 0%, transparent 40%),
    #050505;

  @media screen and (max-width: 768px) {
    padding: 80px 0;
  }
`;

export const MaxWidth = styled.div`
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 50px;

  @media screen and (max-width: 768px) {
    padding: 0 24px;
  }
`;

export const Title = styled(motion.h2)`
  text-align: center;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: ${(props) => props.theme.text};
  margin-bottom: 10px;
`;

export const Heading = styled(motion.h1)`
  text-align: center;
  font-size: 42px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 56px;
  font-family: 'Poppins', sans-serif;

  @media screen and (max-width: 768px) {
    font-size: 30px;
    margin-bottom: 40px;
  }
`;

export const Group = styled.div`
  margin-bottom: 44px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const GroupTitle = styled(motion.h3)`
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: #8b94a3;
  margin-bottom: 20px;
  padding-left: 14px;
  border-left: 3px solid ${(props) => props.theme.text};
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 16px;

  @media screen and (max-width: 480px) {
    grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
    gap: 12px;
  }
`;

export const Card = styled(motion.div)`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px 20px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.035);
  border: 1px solid rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(8px);
  transition: transform 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease;
  cursor: default;

  &:hover {
    transform: translateY(-5px);
    border-color: ${(props) => props.theme.text};
    box-shadow: 0 16px 40px -18px ${(props) => props.theme.text};
  }

  svg {
    font-size: 30px;
    flex-shrink: 0;
    color: ${({ $brand }) => $brand || '#fff'};
  }

  span {
    font-size: 15px;
    font-weight: 600;
    color: #e9edf5;
  }

  @media screen and (max-width: 480px) {
    padding: 14px 16px;
    gap: 10px;
    svg { font-size: 24px; }
    span { font-size: 14px; }
  }
`;
